import {
  GetProviderScheduleResponse,
  ScheduleV0,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import type { Nullable } from '@provider-portal/common/types/types';
import { ActionType, createAsyncAction } from 'typesafe-actions';

export const getScheduleAsyncAction = createAsyncAction(
  '@scheldue/GET_SCHEDULE_START',
  '@scheldue/GET_SCHEDULE_SUCCESS',
  '@scheldue/GET_SCHEDULE_FAILURE',
)<void, GetProviderScheduleResponse, Error>();

export const updateScheduleAsyncAction = createAsyncAction(
  '@scheldue/UPDATE_SCHEDULE_START',
  '@scheldue/UPDATE_SCHEDULE_SUCCESS',
  '@scheldue/UPDATE_SCHEDULE_FAILURE',
)<{ providerId: Nullable<number>; schedule: ScheduleV0 }, void, Error>();

export type ScheduleActions =
  | ActionType<typeof getScheduleAsyncAction>
  | ActionType<typeof updateScheduleAsyncAction>;
